import { render, staticRenderFns } from "./consent-account-view.vue?vue&type=template&id=3105d9cc&scoped=true"
import script from "./consent-account-view.vue?vue&type=script&lang=js"
export * from "./consent-account-view.vue?vue&type=script&lang=js"
import style0 from "./consent-account-view.vue?vue&type=style&index=0&id=3105d9cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3105d9cc",
  null
  
)

export default component.exports